

















import { computed, defineComponent } from '@vue/composition-api';

import getHubs from '@/gql/company/getHubs.gql';

const CommonHubSelector = defineComponent({
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    placeholder: { default: 'เลือก Hub' },
    label: { default: '' },
    level: {},
    rules: { default: '' },
    multiple: { default: false },
    small: { default: false },
  },
  setup(props) {
    const internalValue = computed(() => props.value);

    return {
      getHubs,
      internalValue,
    };
  },
});

export default CommonHubSelector;
